module.exports = __webpack_public_path__ + "img/guanwang_2.5351d64d.png";